export default __webpack_public_path__ + "eye-svgrepo-com.9fa744aa.svg";